import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { getMaterialesTecnicos } from 'src/store/actions/api'

export const useMaterialesTecnicos = () => {

  const dispatch = useDispatch()

  const materiales = useSelector(s => s.api.materialesTecnicos)
  const isLoaded = !!materiales

  useEffect(() => {
    if (!isLoaded) {
      dispatch(getMaterialesTecnicos())
    }
  }, [dispatch, isLoaded])

  return {
    materiales,
    materialesList: (materiales && materiales.value && materiales.value.listado) || []
  }
}
